module.exports = __webpack_public_path__ + "static/media/warning_bar.5d9ff9e7.svg";